import { Box } from "@chakra-ui/react";
import { getAvatarHexColor } from "utils/avatar";

const SIZE_MAP = {
  "2xs": 20,
  xs: 24,
  sm: 32,
  md: 40,
  lg: 48,
  xl: 56,
  "2xl": 72,
};

function resolveSize(size) {
  if (typeof size === "number") return size;
  if (typeof size === "string" && SIZE_MAP[size]) return SIZE_MAP[size];
  const parsed = Number.parseInt(size, 10);
  return Number.isFinite(parsed) ? parsed : 36;
}

function initialsFor(name) {
  return (name || "?")
    .trim()
    .split(/\s+/)
    .map((word) => word[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

const AppAvatar = ({ name, src, size = 36, color, seed, alt, ...props }) => {
  const px = resolveSize(size);
  const label = name || alt || "";
  const bg = color || getAvatarHexColor(seed || label);

  if (src) {
    return (
      <Box
        w={`${px}px`}
        h={`${px}px`}
        borderRadius="50%"
        overflow="hidden"
        flexShrink={0}
        {...props}
      >
        <img
          src={src}
          alt={alt || label}
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
      </Box>
    );
  }

  return (
    <Box
      w={`${px}px`}
      h={`${px}px`}
      borderRadius="50%"
      bg={bg}
      flexShrink={0}
      userSelect="none"
      display="flex"
      alignItems="center"
      justifyContent="center"
      color="white"
      fontFamily="display"
      fontSize={`${Math.round(px * 0.36)}px`}
      fontWeight="700"
      lineHeight="1"
      {...props}
    >
      {initialsFor(label)}
    </Box>
  );
};

export default AppAvatar;
export { AppAvatar };
